import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

interface EditOtpSmsNotificationsParams {
  client_id: string;
  enabled: boolean;
}

/**
 * Turns driver OTP SMS notifications on or off for a client. Driver OTP always sends on Loop's own
 * cm.com account, so there is no per-client provider or product token to pass here.
 * @function
 * @param {EditOtpSmsNotificationsParams} params - The parameters for updating OTP SMS settings.
 *
 * @throws {Error}
 * @returns {Promise<any>}
 */
export const editOtpSmsNotifications = async ({
  client_id,
  enabled
}: EditOtpSmsNotificationsParams) => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const uri = `${config.uri.base_url}/clients/${client_id}/edit-otp-sms-notifications`;

    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({ enabled })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
